module.exports = __webpack_public_path__ + "static/media/no-notifications.710ec209.svg";